import { createFileRoute } from "@tanstack/react-router";

import { stringListParam, stringParam } from "../../../lib/url-state";
import {
  ComparePage,
  type CompareSearch,
} from "../../../workspaces/training/pages/ComparePage";

const MAX_RUNS = 8;

export const Route = createFileRoute("/_console/p/$org/$project/training/compare")({
  validateSearch: (search: Record<string, unknown>): CompareSearch => ({
    runs: stringListParam(search.runs, MAX_RUNS),
    metric: stringParam(search.metric),
  }),
  component: CompareRoute,
});

function CompareRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ComparePage
      search={search}
      onSearchChange={(patch, options) =>
        void navigate({
          search: (current) => ({ ...current, ...patch }),
          replace: options?.replace,
        })
      }
    />
  );
}
